module.exports = __webpack_public_path__ + "static/media/cancer-ico-purple.0a47b165.svg";